/* eslint-disable import/no-mutable-exports */
import React from 'react';
import { Center, Image } from '@chakra-ui/react';
import { TTemplate } from '@/helpers/createTemplate';
import empty from '@/assets/betblast/images/betslip/empty.png';

export const template: TTemplate = {
  wrapper: <Center />,
  empty: <Image src={empty} h="183px" mt="4" />,
};

export default template;
